import { Phone, CheckCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../components/ui/accordion';
import '../ServicePage.css';

const NeurologicalService = () => {
  const whatsappUrl = 'https://wa.me/919886332528';
  const conditions = ['Stroke rehabilitation', 'Paralysis recovery', 'Parkinson\'s disease', 'Multiple sclerosis', 'Cerebral palsy', 'Spinal cord injuries', 'Peripheral nerve injuries', 'Balance and coordination disorders'];
  const equipment = ['Gait training equipment', 'Parallel bars', 'Balance boards', 'TENS/IFT therapy', 'Exercise rehabilitation'];

  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>Neurological Physiotherapy</h1>
          <p className="service-subtitle">Expert care for stroke, paralysis, and neurological conditions</p>
        </div>
      </div>

      <section className="section">
        <div className="container service-container">
          <div className="service-content">
            <h2>What is Neurological Physiotherapy?</h2>
            <p>Neurological physiotherapy specializes in treating individuals with neurological conditions affecting movement, balance, and coordination. Our expert physiotherapists help improve mobility, independence, and quality of life through targeted rehabilitation programs.</p>

            <h2>Conditions We Treat</h2>
            <ul className="conditions-list">
              {conditions.map((condition, index) => (
                <li key={index}>
                  <CheckCircle size={20} />
                  <span>{condition}</span>
                </li>
              ))}
            </ul>

            <h2>What to Expect at Our Clinic</h2>
            <p>We conduct comprehensive neurological assessments including muscle tone evaluation, balance testing, and functional movement analysis. Treatment focuses on retraining movement patterns, improving balance, and maximizing independence.</p>

            <h2>Equipment Used</h2>
            <div className="equipment-tags">
              {equipment.map((item, index) => (<span key={index} className="equipment-tag">{item}</span>))}
            </div>

            <div className="service-cta">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-primary">
                <Phone size={20} />Book Appointment on WhatsApp
              </a>
            </div>

            <h2>Frequently Asked Questions</h2>
            <Accordion type="single" collapsible className="service-faq">
              <AccordionItem value="item-1">
                <AccordionTrigger>When should I start physiotherapy after a stroke?</AccordionTrigger>
                <AccordionContent>Ideally, physiotherapy should begin as soon as you're medically stable, often within 24-48 hours after a stroke. Early intervention leads to better recovery outcomes.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-2">
                <AccordionTrigger>Can neurological physiotherapy help with Parkinson's?</AccordionTrigger>
                <AccordionContent>Yes, physiotherapy is essential for managing Parkinson's symptoms. We help improve mobility, reduce rigidity, enhance balance, and maintain independence for as long as possible.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-3">
                <AccordionTrigger>Do you provide home visits for neurological patients?</AccordionTrigger>
                <AccordionContent>Absolutely. Many neurological patients have difficulty traveling, so we provide specialized home visit services across Goa with experienced neurological physiotherapists.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-4">
                <AccordionTrigger>How long does neurological rehabilitation take?</AccordionTrigger>
                <AccordionContent>Recovery timelines vary significantly based on the condition and severity. Some patients see improvement in weeks, while others need ongoing therapy for months or years. We create personalized long-term care plans.</AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NeurologicalService;